<div class="response-element" [formGroup]="keywordGroup">
  <label>{{keywordGroup.get('Keyword').value}}:</label>
  <textarea class="form-control" formControlName="Message" rows="5" ></textarea>
  @if (!keywordGroup.valid) {
    <i>A message must be provided.</i>
  }
</div>
